import CommonStartNew from '../../CommonViews/StartNew';
import { CALC_PAGE_TYPES } from 'utils/calculatorUtils';

const StartNew = (props) => <CommonStartNew {...props} pageType={CALC_PAGE_TYPES.BENCHMARK} />;

export default StartNew;
